import { Component, Input } from '@angular/core';
import { KngActivityIndicatorService } from '@layout/kingswell/services/kngActivityIndicator.service';
import { BroadcasterService } from '@core/broadcaster/broadcaster.service';

@Component({
  selector: 'kng-activity-indicator',
  templateUrl: './kng-activity-indicator.component.html'
})
export class KngActivityIndicatorComponent {

  ACTIVITY_INDICATOR_TIMEOUT = 1000;

  public open: boolean = true;
  private isTaskDone = true;

  constructor(private broadcaster: BroadcasterService) {
    this.broadcaster.on('kng-activity-indicator.open').subscribe(data => {
      this.isTaskDone = false;
      setTimeout(() => {
        if (!this.isTaskDone)
          this.show();
      }, this.ACTIVITY_INDICATOR_TIMEOUT);
    });
    this.broadcaster.on('kng-activity-indicator.close').subscribe(data => {
      this.close();
    });
  }

  close() {
    this.open = false;
    this.isTaskDone = true;
  }

  show() {
    this.open = true;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-activity-indicator/kng-activity-indicator.component.ts